// extracted by mini-css-extract-plugin
module.exports = {"post":"b177a4","post__content":"_88bf40","post__header":"b70866","post__content-text":"_192ad4","post__attachments":"fe7325"};